// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Create/risk.css
// module id = 656
// module chunks = 0